import { StatRec } from '@/components/common/Stat'
import { type RecType } from '@/defs/rec'
import { type StatType } from '@/defs/stat'
import { cn } from '@/utils/commonUtil'

import styles from './CardRecStats.module.scss'

type Props = {
  rec: RecType
  size?: 'sm'
  stats: StatType[]
}

export const CardRecStats = ({ rec, size, stats }: Props) =>
  stats.length > 0 && (
    <div className={cn(styles.container, { count: String(Math.min(stats.length || 0, 3)), size, styles })}>
      <ul className={styles.inner}>
        {stats.map((stat) => (
          <li className={styles.item} key={stat}>
            <StatRec rec={rec} stat={stat} />
          </li>
        ))}
      </ul>
    </div>
  )
